export default __webpack_public_path__ + "static/media/arrow-up.f4cc0951.svg";